import React from "react";
import { NumberInput } from "../commons/NumberInput";
import { I18N } from "oc-I18N";

type SizeNumberProps = {
  value: number;
  setter: (value: number) => void;
  min: number;
  max: number;
  disabled: boolean;
  className?: string;
  onFocus?: (e: React.FocusEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  dataInputKey?: string;
  decimals?: number;
  unit?: string;
  step?: number;
  workOnInternValue?: boolean;
  ariaLabel?: string;
};

export function SizeNumber({
  value,
  setter,
  min,
  max,
  disabled,
  className = "",
  onFocus,
  onBlur,
  dataInputKey,
  decimals = 2,
  unit = "m",
  step = 0.1,
  workOnInternValue = false,
  ariaLabel,
}: SizeNumberProps) {
  const agt = APP.arrangement;
  return (
    <>
      <NumberInput
        className={"abstandInput ml8" + (disabled ? "disabled" : "") + className}
        dataInputKey={dataInputKey}
        ariaLabel={ariaLabel}
        value={value}
        setValue={(value) => {
          const selectedZaunelementOrPfosten = agt.selectedObjects[0];
          if (selectedZaunelementOrPfosten == null) {
            return;
          }
          setter(value);
          APP.dirty();
        }}
        decimals={decimals}
        unit={unit}
        min={min}
        max={max}
        step={step}
        disabled={disabled}
        onFocus={onFocus}
        onBlur={onBlur}
        roundToMinMax={true}
        workOnInternValue={workOnInternValue}
        warningDiv={(internValue) => {
          const v = I18N.parseFloat(internValue, max);
          // if (v > max) {
          //   debugger;
          //   I18N.parseFloat(internValue);
          // }
          return v < min ? (
            <div className="number-input-warning">
              {I18N("der Mindestwert ist %s", I18N.formatFloat(min))}
            </div>
          ) : v > max ? (
            <div className="number-input-warning">
              {I18N("der Maximalwert ist %s", I18N.formatFloat(max))}
            </div>
          ) : null;
        }}
      />
    </>
  );
}
